import { render, staticRenderFns } from "./QtyDatatable.vue?vue&type=template&id=36a635f0"
import script from "./QtyDatatable.vue?vue&type=script&lang=js"
export * from "./QtyDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports